import FileJoinKnglib from './src/main';

/* istanbul ignore next */
FileJoinKnglib.install = function(Vue) {
  Vue.component(FileJoinKnglib.name, FileJoinKnglib);
};

export default FileJoinKnglib;
